import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-checkbox.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-checkbox.component.css?ngResource";
import { Component } from '@angular/core';
let CalciteCheckboxComponent = class CalciteCheckboxComponent {
    constructor() { }
    ngOnInit() {
    }
    static ctorParameters = () => [];
};
CalciteCheckboxComponent = __decorate([
    Component({
        selector: 'lib-calcite-checkbox',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteCheckboxComponent);
export { CalciteCheckboxComponent };
